import { Injectable } from '@angular/core';

@Injectable()
export class GeocodingLocationProvider {
  geocode(
    request: google.maps.GeocoderRequest,
    callback?: ((a: google.maps.GeocoderResult[] | null, b: google.maps.GeocoderStatus) => void) | null,
  ): Promise<google.maps.GeocoderResponse> {
    const geocoder = new google.maps.Geocoder();
    return geocoder.geocode(request, callback);
  }
}
